var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treatment-step",class:{ active: _vm.needAction, pending: !_vm.needAction, 'is-tag': _vm.isTag }},[_c('div',{staticClass:"dot"}),_c('span',[_vm._v(_vm._s(_vm.TreatmentStepLabel[_vm.step]))])])}
var staticRenderFns = []

export { render, staticRenderFns }